import Vue from 'vue'
import Router from 'vue-router'

// Import tĩnh module home để trang home load ngay
import HomeRouters from '@/modules/home'

Vue.use(Router)

// Các route không cần đăng nhập
const passRoutes = new Set([
  '/login',
  '/digital-service',
  '/mobile/home',
  '/ftth/login',
  '/callback',
  '/mobile/callback',
  '/mobile/roaming-privacy-term',
  '/mobile/data-roaming',
  '/shop-unitel/buy-sim',
  '/shop-unitel/buy-sim/step-2',
  '/shop-unitel/buy-sim/step-3',
  '/shop-unitel/buy-sim/success',
  '/shop-unitel/buy-ftth',
  '/shop-unitel/buy-ftth/step-2',
  '/shop-unitel/buy-ftth/step-3',
  '/shop-unitel/buy-ftth/success',
  '/shop-unitel/buy-device',
  '/shop-unitel/buy-device/step-2',
  '/shop-unitel/buy-device/step-3',
  '/shop-unitel/buy-device/success',
  '/qr/scan',
  '/qr/login',
  '/qr/config',
  '/qr/create-errors-report',
  '/qr/report-history',
  '/qr/ftth-service',
  '/qr/preliminary-treatment',
  '/qr/success',
  '/package-special',
  '/package-special/mobile',
  '/package-special/ftth',
  '/package-special/roaming',
  '/package-special/vas',
  '/services/qrcodeads/getlink',
  '/services/qrcodeads/error',
  '/mobile/notification-qr'
])

// Import các module khác bằng dynamic import để chia nhỏ bundle
const loadDynamicRoutes = async () => {
  const [
    { default: MobileRouters },
    { default: UcareRouters },
    { default: NotificationRouters },
    { default: FTTHRouters },
    { default: Convert },
    { default: ShopRouters },
    { default: QrRouters },
    { default: PackageSpecialRouters }
  ] = await Promise.all([
    import('@/modules/mobile'),
    import('@/modules/ucare'),
    import('@/modules/notification-center'),
    import('@/modules/ftth'),
    import('@/modules/convert'),
    import('@/modules/shop-unitel'),
    import('@/modules/qr-code'),
    import('@/modules/package-special')
  ])

  return [
    ...MobileRouters,
    ...UcareRouters,
    ...NotificationRouters,
    ...FTTHRouters,
    ...Convert,
    ...ShopRouters,
    ...QrRouters,
    ...PackageSpecialRouters
  ]
}

// Hàm tạo router (được export để gọi trong main.js)
const createRouter = async () => {
  const dynamicRoutes = await loadDynamicRoutes()

  const router = new Router({
    mode: 'hash', // bạn có thể đổi sang 'hash' nếu server không hỗ trợ history
    routes: [
      ...HomeRouters,
      ...dynamicRoutes
    ],
    scrollBehavior(to) {
      if (to?.meta?.disableScroll) return
      return { x: 0, y: 0, behavior: 'smooth' }
    }
  })

  // Xử lý điều hướng
  router.beforeEach(async (to, from, next) => {
    const { isAuthenticated, checkToSetAuthenticate } = await import('@/ultils/user')
    const { callNative } = await import('@/ultils/call-native')

    if (passRoutes.has(to.path)) return next()

    if (await checkToSetAuthenticate(to.path, to.query)) return next()

    if (isAuthenticated(to.path)) return next()

    if (!to.path.includes('/ftth')) {
      if (to.path !== '/home') {
        callNative('login', '')
      }
      return next({ path: '/login' })
    } else {
      return next({ path: '/ftth/login' })
    }
  })

  return router
}

export default createRouter
